module.exports = __webpack_public_path__ + "asset/agm-proxy-form--d82958.png";